import { Slugs } from '@thinkalpha/common/constants/slugs.js';
import { ColumnTemplate as ColumnTemplateSchema } from '@thinkalpha/platform-ws-client/contracts/column-template.js';
import type { RowKey } from '@thinkalpha/platform-ws-client/contracts/table.js';
import type { KnownColumnTemplateKey, SuggestedColumnsKey } from '@thinkalpha/ui-types/contracts/column-template';
import type { SlugMapDict } from 'src/lib/dictionary/dictionary';
import type { AggregatedRiskTableKind } from 'src/queries/aggregatedRiskTables';
import { z } from 'zod';

export interface AggregatedRiskWidgetConfig {
    tableKind: AggregatedRiskTableKind;
    sourceKey: RowKey;
    templateKey: KnownColumnTemplateKey;
    suggestedColumnsKey: SuggestedColumnsKey;
    indicatorKey: string | readonly string[];
    groupBySlug: keyof SlugMapDict;
}

export const columnTemplateStateSchema = z.union([ColumnTemplateSchema, z.string(), z.null()]).default(null);

export const AGGREGATED_RISK_WIDGET_CONFIG_BY_KIND = {
    traders: {
        tableKind: 'traders',
        sourceKey: 'Position',
        templateKey: 'Positions::Agg(Trader)',
        suggestedColumnsKey: 'positions',
        indicatorKey: ['ticker', 'Position'],
        groupBySlug: Slugs.accountTrader,
    },
    platforms: {
        tableKind: 'platforms',
        sourceKey: 'Position',
        templateKey: 'Positions::Agg(Platform)',
        suggestedColumnsKey: 'positions',
        indicatorKey: ['ticker', 'Position'],
        groupBySlug: Slugs.accountPlatform,
    },
    symbols: {
        tableKind: 'symbols',
        sourceKey: 'Position',
        templateKey: 'Positions::Agg(Symbol)',
        suggestedColumnsKey: 'positions',
        indicatorKey: ['ticker', 'Position'],
        groupBySlug: Slugs.positionSymbol,
    },
} as const satisfies Record<AggregatedRiskTableKind, AggregatedRiskWidgetConfig>;
